import React, { useState, useRef } from "react";

import AddButton from "src/app/components/AddButton/AddButton";
import { AccumulatedLabels } from "src/app/components/Select/components/AccumulatedLabels/AccumulatedLabels";
import SelectDropdown from "src/app/components/SelectDropdown/SelectDropdown";
import DropdownPortal from "src/app/components/DropdownPortal";
import { useScrollLock } from "src/app/methods/useScrollLock";
import useOnClickOutside from "src/app/methods/useOnClickOutside";
import useGlobalCreatorDropdownData from "./hooks/useGlobalCreatorDropdownData";

interface GlobalCreatorDropdownProps {
  fieldValue: string[] | null | undefined;
  handleUpdateValue: (values: string[]) => void;
  readOnly?: boolean;
}

export default function GlobalCreatorDropdown({
  fieldValue,
  handleUpdateValue,
  readOnly,
}: GlobalCreatorDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [
    handleSelectOption,
    handleUnselectOption,
    handleUserQuery,
    selectedOptions,
    options,
    isLoading,
  ] = useGlobalCreatorDropdownData({
    fieldValue,
    handleUpdateValue,
  });

  const { lockScroll, unlockScroll } = useScrollLock();
  useOnClickOutside(dropdownRef, () => {
    unlockScroll();
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const handleLabelClick = () => {
    if (!readOnly) {
      lockScroll();
      setIsOpen(true);
    }
  };

  const renderValue = () => {
    if (selectedOptions.length > 0) {
      return (
        <AccumulatedLabels
          multiValue={selectedOptions}
          setIsOpen={setIsOpen}
          handleLabelClick={handleLabelClick}
          emptyFieldPlaceholder={<AddButton variant="rect" />}
        />
      );
    }
    return <AddButton variant="rect" onClick={handleLabelClick} />;
  };

  return (
    <div className="select__wrapper" ref={dropdownRef}>
      <DropdownPortal
        className="select__dropdown"
        visible={isOpen}
        overlay={
          <SelectDropdown
            options={options}
            selectedOptions={selectedOptions}
            handleUserQuery={handleUserQuery}
            handleUnselectOption={handleUnselectOption}
            handleSelectOption={handleSelectOption}
            handleLabelClick={handleLabelClick}
            isOpen={isOpen}
            isLoading={isLoading}
            inputPlaceholder={{
              id: "ws_search_global_creator",
              defaultMessage: "Type to find a global creator",
            }}
          />
        }
      >
        {renderValue()}
      </DropdownPortal>
    </div>
  );
}
